import React from 'react';
import { useParams, Link } from 'react-router-dom';
import Header from '../../components/Header';
import SEO from '../../components/SEO';
import { blogPosts } from '../../content/blogPosts';

const PostPage = () => {
  const { slug } = useParams();
  const post = blogPosts.find((item) => item.slug === slug);

  if (!post) {
    return (
      <main>
        <SEO title="Post not found | Keyif" description="Requested blog post could not be found." />
        <Header />
        <section className="blog-post">
          <h1>Post not found</h1>
          <p>The blog post you are looking for does not exist.</p>
          <Link to="/blog">Back to blog</Link>
        </section>
      </main>
    );
  }

  return (
    <main>
      <SEO
        title={`${post.title} | Keyif`}
        description={post.description}
        image={post.image}
      />
      <Header back />
      <section className="blog-post">
        <h1>{post.title}</h1>
        <p className="blog-post-date">{post.date}</p>
        <article
          className="blog-post-content"
          dangerouslySetInnerHTML={{ __html: post.content }}
        />
        <p>
          <Link to="/blog">Back to blog</Link>
        </p>
      </section>
    </main>
  );
};

export default PostPage;
